import { useSearchList } from "./service";
import ListHead from "components/subHead/listHead";
import Grid from "components/grid";

type IProps = {
  param: any;
};

export default function ManagerList({ param }: IProps) {
  const { rowData, pageNav } = useSearchList({ param });

  const theads = [
    ...prevTheads,
    {
      langNm: "grid_status",
      type: "string",
      field: "uYn",
      width: 80,
      styles: "cursor-pointer font-bold",
      click: (params: any) => {
        // 상태변경
      },
    },
    {
      langNm: "grid_detail",
      type: "btn",
      field: "detail",
      width: 80,
      styles: "text-navy-300 cursor-pointer",
      click: (props: any) => {
        // 상세
      },
    },
    {
      langNm: "grid_edit",
      type: "btn",
      field: "modify",
      width: 80,
      styles: "text-navy-300 cursor-pointer",
      click: (params: any) => {
        // onSetAlert({
        //   isOpen: true,
        //   inner: t("to_update"),
        //   cnclBtn: true,
        //   onSetConfirm: () => {
        //     navigate("", {
        //       state: {
        //         ...state,
        //         page: {
        //           active: true,
        //           current: true,
        //           tCode: "Member",
        //           code: "PM21",
        //           props: {
        //             manNo: params.data.manNo,
        //           },
        //         },
        //       },
        //     });
        //   },
        // });
      },
    },
  ];
  return (
    <>
      <ListHead totalRows={pageNav?.totalRows || 0} />
      <Grid theads={theads} rowData={rowData} pageNav={pageNav} />
    </>
  );
}

const prevTheads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 60,
  },
  {
    langNm: "grid_mem_no",
    type: "string",
    field: "manNo",
    width: 300,
  },
  {
    langNm: "grid_mem_surnm",
    type: "string",
    field: "manSurnm",
    width: 80,
  },
  {
    langNm: "grid_mem_fstnm",
    type: "string",
    field: "manFstnm",
    width: 140,
  },
  {
    langNm: "grid_eml",
    type: "string",
    field: "emlId",
    width: 300,
  },
  {
    langNm: "grid_phone",
    type: "phone",
    field: "mobNo",
    width: 140,
  },
];
